/**
 * 数据埋点
 */
import store from '@/store'
import router from '@/router'
import API from '@/api'

// 上一次埋点数据时间戳
let lastTime = new Date().getTime()
// 页面观看总时长
let totalTime = 0

/**
 * 重构数据埋点
 * @param {*} recordParam 埋点参数
 */
export function record(recordParam) {
  let nowTime = new Date().getTime()
  // 操作区间超过3分钟按三分钟来计。
  if (nowTime - lastTime >= 3 * 60 * 1000) totalTime += 3 * 60 * 1000
  else totalTime += nowTime - lastTime
  lastTime = nowTime
  // 隐藏是记录时间段
  if (['hide', 'refresh'].includes(recordParam.eventType)) recordParam.totalTime = totalTime
  // 页面打开重置记录时间
  if (recordParam.eventType === 'show') totalTime = 0
  const recordObj = {
    sessionId: sessionStorage.getItem('kk_sessionId') || '', // 页面会话id (uuid)
    fullPath: location.href, // 页面全路径
    pageId: (router.app && router.app._route && router.app._route.meta.pageId) || '', // 页面id
    // prePageId: from.meta.pageId, // 上个页面的页面id
    pageRequestId: sessionStorage.getItem('kk_pageRequestId') || '', // 页面刷新生成id（ 生成一个 PRId + 时间戳）
    userId: store.state.common.userId || '', // 用户id
    time: lastTime, // 时间戳
    referrer: localStorage.getItem('referrer') || '', // 页面来源
    loginId: store.state.common.jti || '', // 登录id
    appName: 'kakaclo',
    // eventType: 'open', // 埋点类型
    // eventId: `${pageId}_${eventType}`, // 事件类型id
    deviceInfo: JSON.stringify({ // 设备信息
      resolution: `${window.screen.width}*${window.screen.height}`,
      system: navigator.userAgent,
      ul: navigator.language
    }),
    value: '' // 业务参数信息 json
  }

  if (recordParam.eventType === 'refresh') {
    let data = { ...recordObj, ...recordParam }
    // delete data.deviceInfo
    const blob = new Blob([JSON.stringify(data)], {
      type: 'application/json; charset=UTF-8'
    })
    navigator.sendBeacon(process.env.VUE_APP_REPORT_URL + '/api/report/open/tracking', blob)
    return
  }

  API.tracking({
    ...recordObj,
    ...recordParam
  })
}

/**
 * 老埋点

async function getLocation() {
  let location = sessionStorage.getItem('ipLocation') && JSON.parse(sessionStorage.getItem('ipLocation'))
  if (!location) {
    let res = await API.getSystemIP()
    if (res.code === 10000) {
      let l = res.data.location ? JSON.parse(res.data.location) : {}
      res.data.lng = l.lng
      res.data.lat = l.lat
      location = res.data
      sessionStorage.setItem('ipLocation', JSON.stringify(location))
    }
  }
  return location || {}
}

export async function report(eventTypeId, value) {
  if (!eventTypeId) return
  const userId = store.state.common.userId || undefined
  const location = await getLocation()
  // API.report({
  //   eventTypeId,
  //   value: typeof value === 'object' ? JSON.stringify(value) : value,
  //   ip: location.ip,
  //   userId,
  //   address: location.country,
  //   longitude: location.lng,
  //   latitude: location.lat,
  //   referrer: localStorage.getItem('referrer') || undefined,
  //   equipment: store.state.isPC ? 'pc' : 'mobile',
  //   jti: store.state.common.jti
  // })
}

export async function sendBeacon(event_type_id, value) {
  if (!event_type_id) return
  const formData = new FormData()
  const user_id = store.state.common.userId || undefined
  const location = await getLocation()
  const referrer = localStorage.getItem('referrer')
  formData.append('event_type_id', event_type_id)
  formData.append('value', value)
  formData.append('ip', location.ip)
  user_id && formData.append('user_id', user_id)
  formData.append('address', location.country)
  formData.append('longitude', location.lng)
  formData.append('latitude', location.lat)
  referrer && formData.append('referrer', referrer)
  formData.append('equipment', store.state.isPC ? 'pc' : 'mobile')
  formData.append('jti', store.state.common.jti)
  // return navigator.sendBeacon('/api/report/open/buried', formData)
}

*/
